class Manager {

  constructor() {
    this.nodes = []
  }

  add(node) {
    this.nodes.push(node)
  }

  filterItems() {
    return this.nodes.filter((node) => !node.dndData.disabled)
  }

  getNodeIndex(node, nodes) {
    nodes = nodes || this.nodes

    return nodes.findIndex((item) => item === node)
  }

  flush() {
    this.nodes = []
  }
}


export default Manager
